import styled from 'styled-components';

export const VoterRegistrationWrapper = styled.div`
    h2 {
        margin: 10px 0;
    }
`;

export const GridStyledWrapper = styled.div<{ maxWidth?: string }>`
    max-width: ${({ maxWidth }) => maxWidth || '100%'};
    display: grid;
    grid-template-columns: repeat(2, 1fr);

    @media (max-width: 768px) {
        max-width: 100%;
        grid-template-columns: ${({ maxWidth }) => (maxWidth === '50%' ? 'repeat(2, 1fr)' : 'repeat(1, 1fr)')};
    }

    gap: 16px 50px;

    h2 {
        margin: 10px 0;
    }

    input,
    select,
    label {
        width: 100%;
    }

    label {
        float: left;
        padding-left: unset;
        text-align: left;
        margin-bottom: 0.5rem !important;
    }

    .fullWidth {
        grid-column: 1 / -1;
    }

    > .empty {
        @media (max-width: 768px) {
            display: none;
        }
    }
`;

export const FullWidthWrapper = styled.div`
    input,
    select {
        width: 95%;
    }
`;

export const StyledErrorMessage = styled.div`
    color: red;
`;

export const StyledDatePicker = styled.div`
    .datePicker {
        display: flex;
        flex-direction: column;
    }
`;

export const StyledRadioButton = styled.div`
    display: flex;
    align-items: center;
`;

export const StyledPoliticalPartyRadioButtons = styled.div`
    .gi-radio_buttons {
        margin-bottom: 0;
    }
`;

export const StyledOtherPartyInputContainer = styled.div`
    display: flex;
    width: 100%;

    > div {
        flex: 0 0 65%;
        margin-left: 24px;

        @media (max-width: 768px) {
            flex: 0 0 100%;
            margin-left: 0;
        }
    }
`;

export const StyledDeclarationContainer = styled.div`
    margin-top: 2rem;
    padding: 2rem;
    border: 1px solid ${({ theme }) => theme.gray7};
    background: ${({ theme }) => theme.gray11};
    border-radius: 0.5rem;
`;

export const StyledVoterRegistrationFooter = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 1.5rem;
    margin-top: 1.5rem;

    @media (max-width: 412px) {
        flex-direction: column;
    }
`;

export const StyledModalButtonFooter = styled.div`
    display: flex;
    gap: 12px;
    justify-content: flex-end;

    div {
        flex: 1;
    }
`;

export const StyledIdentificationSubheader = styled.label`
    margin-bottom: 1rem;
    display: block;
`;